import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import applyReducer from './applyReducer';
import reportDocumentConstants from '../constants/reportDocumentConstants';
const initState = {
  pdfPath: null,
  downloadPDFPath: null,
  annotations: [],
  displayName: 'loading...',
  error: null,
  parentReportID: null,
  reportDocumentID: null,
  reportTypeID: null
};
const renderSuccess = (state, _ref) => {
  let pdfPath = _ref.pdfPath,
    displayName = _ref.displayName,
    annotations = _ref.annotations,
    parentReportID = _ref.parentReportID,
    reportDocumentID = _ref.reportDocumentID,
    reportTypeID = _ref.reportTypeID;
  return _objectSpread(_objectSpread({}, state), {}, {
    pdfPath,
    displayName,
    annotations,
    parentReportID,
    reportTypeID,
    reportDocumentID
  });
};
const renderFailure = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  error: "Failed to render report document with ID: ".concat(action.reportDocumentID)
});
const reset = state => _objectSpread(_objectSpread({}, state), initState);
const clearDownloadPDFPath = state => _objectSpread(_objectSpread({}, state), {}, {
  downloadPDFPath: null
});
const renderAnnotatedSuccess = (state, _ref2) => {
  let downloadPDFPath = _ref2.data.downloadPDFPath;
  return _objectSpread(_objectSpread({}, state), {}, {
    downloadPDFPath
  });
};
const renderAnnotatedFailure = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  error: "Failed to render annotated report document with ID: ".concat(action.reportDocumentID)
});
const reducers = {
  [reportDocumentConstants.RENDER_FAILURE]: renderFailure,
  [reportDocumentConstants.RENDER_SUCCESS]: renderSuccess,
  [reportDocumentConstants.RESET]: reset,
  [reportDocumentConstants.RENDER_ANNOTATED_FAILURE]: renderAnnotatedFailure,
  [reportDocumentConstants.RENDER_ANNOTATED_SUCCESS]: renderAnnotatedSuccess,
  [reportDocumentConstants.CLEAR_DOWNLOAD_PATH]: clearDownloadPDFPath
};
export default applyReducer(reducers, initState);